import type { RunsSummaryTimeframe } from "./runsSummaryTypes"

const MS_PER_DAY = 24 * 60 * 60 * 1000

const TIMEFRAME_SPANS: Array<{
  timeframe: RunsSummaryTimeframe
  days: number
}> = [
  { timeframe: "24h", days: 1 },
  { timeframe: "7d", days: 7 },
  { timeframe: "30d", days: 30 },
]

/**
 * Tolerance when recognising a summary window in an applied range. The quick
 * presets stamp both bounds from one `Date`, so their spans are exact to the
 * millisecond; a minute absorbs day-boundary presets like Today and any
 * rounding on the way through the URL.
 */
const SPAN_TOLERANCE_MS = 60 * 1000

/** A date range with either bound optional, as the keyset filters express it. */
interface DateRangeBounds {
  start?: Date | null
  end?: Date | null
}

/**
 * The summary window implied by the table's date range, so Sofia describes the
 * runs the operator is looking at.
 *
 * Only ranges spanning a window Sofia reports on can be honoured; a 14-day or
 * hand-picked range falls back to "auto", where the window is chosen adaptively
 * from run volume.
 */
export function toRunsSummaryTimeframe(
  dateRange: DateRangeBounds | null | undefined,
): RunsSummaryTimeframe {
  const start = dateRange?.start
  const end = dateRange?.end

  if (!start || !end) {
    return "auto"
  }

  const spanMs = end.getTime() - start.getTime()
  return (
    TIMEFRAME_SPANS.find(
      (candidate) =>
        Math.abs(spanMs - candidate.days * MS_PER_DAY) <= SPAN_TOLERANCE_MS,
    )?.timeframe ?? "auto"
  )
}
